import React, { useEffect } from 'react';
import cardIcon from "../../../assets/images/svg/card-icon.svg";
import container from "../../../assets/images/svg/container.svg";
import { Button, Row, Col, Modal, Card, CardBody, Form, Label, Input, FormGroup, FormFeedback } from "reactstrap";
import carrier_bl from '../../../assets/images/svg/booking-track/carrier-bl.svg'
import carrier_name from '../../../assets/images/svg/booking-track/carrier-name.svg'
import customer_code from '../../../assets/images/svg/booking-track/customer-code.svg'
import customer_name from '../../../assets/images/svg/booking-track/customer-name.svg'
import division from '../../../assets/images/svg/booking-track/division.svg'
import glottis from '../../../assets/images/svg/booking-track/glottis.svg'
import port_of_delivery from '../../../assets/images/svg/booking-track/port-of-delivery.svg'
import port_of_loading from '../../../assets/images/svg/booking-track/port-of-loading.svg'
import shippment from '../../../assets/images/svg/booking-track/shippment.svg'
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';

const TrackInfo = ({ data }) => {
    const { loading } = useSelector(state => ({
        loading: state.TrackBookings?.loading
    }))
 
    return (
        <>
            <Card className='tract-info'>
                <CardBody>
                    <div className='d-flex align-items-center info-card'>
                        <div className='icon'>
                            <img src={shippment} alt="Dvistion" />
                        </div>
                        <div>
                            <p className='m-0'>Shippment</p>
                            {loading ? <Skeleton height={"20px"} width={'120px'} /> :
                                <h6>{data && data[0].type}</h6>}
                        </div>
                    </div>
                    <div className='d-flex align-items-center info-card'>
                        <div className='icon'>
                            <img src={division} alt="Dvistion" />
                        </div>
                        <div>
                            <p className='m-0'>Division</p>
                            {loading ? <Skeleton height={"20px"} width={'120px'} /> :
                                <h6>{data && data[0].division}</h6>}
                        </div>
                    </div>
                    <div className='d-flex align-items-center info-card'>
                        <div className='icon'>
                            <img src={port_of_loading} alt="Dvistion" />
                        </div>
                        <div>
                            <p className='m-0'>Port of loading</p>
                            {loading ? <Skeleton height={"20px"} width={'120px'} /> :
                                <h6>{data && data[0].portOfLoading}</h6>}
                        </div>
                    </div>
                    <div className='d-flex align-items-center info-card'>
                        <div className='icon'>
                            <img src={port_of_delivery} alt="Dvistion" />
                        </div>
                        <div>
                            <p className='m-0'>Port of delivery</p>
                            {loading ? <Skeleton height={"20px"} width={'120px'} /> :
                                <h6>{data && data[0].portOfDischarge}</h6>}
                        </div>
                    </div>
                    <div className='d-flex align-items-center info-card'>
                        <div className='icon'>
                            <img src={carrier_bl} alt="Dvistion" />
                        </div>
                        <div>
                            <p className='m-0'>Glottis BL/AWB</p>
                            {loading ? <Skeleton height={"20px"} width={'120px'} /> :
                                <h6>{data && data[0].BL_Number}</h6>}
                        </div>
                    </div>
                    <div className='d-flex align-items-center info-card'>
                        <div className='icon'>
                            <img src={carrier_name} alt="Dvistion" />
                        </div>
                        <div>
                            <p className='m-0'>Carrier name</p>
                            {loading ? <Skeleton height={"20px"} width={'120px'} /> :
                                <h6>{data && data[0].carrierName}</h6>}
                        </div>
                    </div>
                    <div className='d-flex align-items-center info-card'>
                        <div className='icon'>
                            <img src={carrier_bl} alt="Dvistion" />
                        </div>
                        <div>
                            <p className='m-0'>Carrier BL/AWS</p>
                            {loading ? <Skeleton height={"20px"} width={'120px'} /> :
                                <h6>{data && data[0].carrier_BL_number}</h6>}
                        </div>
                    </div>
                    <div className='d-flex align-items-center info-card'>
                        <div className='icon'>
                            <img src={customer_name} alt="Dvistion" />
                        </div>
                        <div>
                            <p className='m-0'>Customer Name</p>
                            {loading ? <Skeleton height={"20px"} width={'120px'} /> :
                                <h6>{data && data[0].customerName}</h6>}
                        </div>
                    </div>
                    <div className='d-flex align-items-center info-card'>
                        <div className='icon'>
                            <img src={customer_code} alt="Dvistion" />
                        </div>
                        <div>
                            <p className='m-0'>Customer Code</p>
                            {loading ? <Skeleton height={"20px"} width={'120px'} /> :
                                <h6>{data && data[0].customerCode}</h6>}
                        </div>
                    </div>
                </CardBody>
            </Card>
        </>
    )
}

export default TrackInfo;